import styled from "styled-components";
import React, { ReactNode } from "react";

export const PageContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const WidePageContainer = styled(PageContainer)`
  max-width: 1400px;
`;

export const NarrowPageContainer = styled(PageContainer)`
  max-width: 600px;
`;

const TitleBase = styled.h1`
  color: #001f52;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #e0e0e0;
  }
`;

type PageTitleProps = {
  children: ReactNode;
  as?: "h1" | "h2";
  noMarginBottom?: boolean;
};

export function PageTitle({ children, as = "h1", noMarginBottom }: PageTitleProps) {
  return (
    <TitleBase
      as={as}
      style={noMarginBottom ? { marginBottom: 0 } : undefined}
    >
      {children}
    </TitleBase>
  );
}

